import React, { useEffect, useState } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts)
require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const PackeBubbleChart: any =(props:any)=>{
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel, labels, title, idChart, activeButton} = props;
    console.log(allData);
    const [Data, setData]= useState(allData);
    const options = {
        chart: {
            type: 'packedbubble',
            height:600,
            backgroundColor: '#f0f0f0',
        },
        title: {
            text: ' Modelo de confianza de Gabriel Boric. Diciembre'
        },
        tooltip: {
            useHTML: true,
            pointFormat: '<b>{point.name}:</b> {point.value} <sub></sub>'
        },
        plotOptions: {
            packedbubble: {
                minSize: '50%',
                maxSize: '100%',
                zMin: 0,
                zMax: 1000,
                layoutAlgorithm: {
                    gravitationalConstant: 0.05,
                    splitSeries: true,
                    seriesInteraction: false,
                    dragBetweenSeries: true,
                    parentNodeLimit: true
                },
                dataLabels: {
                    enabled: true,
                    format: '{point.name}',
                    filter: {
                        property: 'y',
                        operator: '>',
                        value: 2.8
                    },
                    categories:labels,
                    style: {
                        color: 'black',
                        textOutline: 'none',
                    }
                }
            }
        },
        colors:['#ffbf75','#b38471','#75c7ff'],
        
        series: [
            {
                "name": "Atributos Personales: 44,8",
                "data": [
                    {
                        "name": "Tiene carisma ",
                        "value": 3.3
                    },
                    {
                        "name": "Es sólido, consistente, comunica con claridad",
                        "value": 8.3
                    },
                    {
                        "name": "Es honesto, ético, transparente",
                        "value": 10.3
                    },
                    {
                        "name": "Cumple lo que promete",
                        "value": 3.5
                    },
                    {
                        "name": "Es dialogante y genera acuerdos",
                        "value": 0.7
                    },
                    {
                        "name": "Tiene capacidad para gestionar crisis",
                        "value": 4.6
                    },
                    {
                        "name": "Es cercano, conoce las necesidades de las personas",
                        "value": 0.6
                    },
                    {
                        "name": "Tiene capacidad para solucionar los problemas del país",
                        "value": 8.1
                    },
                    {
                        "name": "Cuenta con autoridad y liderazgo",
                        "value": 5.4
                    }
                ]
            },
            {
                "name": "Atributos Políticos: 28,1",		    
                "data": [
                    {
                        "name": "Tiene buenas ideas y  programa de gobierno",
                        "value": 3.3
                    },
                    {
                        "name": "Da garantías de gobernabilidad",
                        "value": 8.0
                    },
                    {
                        "name": "Tiene un diagnóstico claro sobre la situación política y social de Chile",
                        "value": 0.6
                    },
                    {
                        "name": "Cuenta con un buen equipo de gobierno, ministros, subsecretarios",
                        "value": 4.5
                    },
                    {
                        "name": "Podrá liderar los cambios necesarios al ritmo adecuado",
                        "value": 5.4
                    },
                    {
                        "name": "Tendrá una buena relación con la oposición",
                        "value": 1.8
                    },
                    {
                        "name": "Puede liderar los cambios que  traerá la nueva Constitución",
                        "value": 1.0
                    },
                    {
                        "name": "Podrá mantener ordenada a su coalición política ",
                        "value": 3.5
                    }
                ]
            },
            {
                "name": "Atributos de Gestión: 27,1",
                "data": [
                    {
                        "name": "Tiene capacidad para enfrentar la delincuencia y el narcotráfico",
                        "value": 5.8
                    },
                    {
                        "name": "Promoverá la igualdad de género",
                        "value": 2.9
                    },
                    {
                        "name": "Tiene capacidad para hacer cambios en educación y salud",
                        "value": 0.3
                    },
                    {
                        "name": "Tiene capacidad para mantener el orden público",
                        "value": 6.4
                    },
                    {
                        "name": "Tiene capacidad para gestionar el conflicto en La Araucanía",
                        "value": 1.5
                    },
                    {
                        "name": "Tiene capacidad para hacer crecer la economía y volver a generar empleo",
                        "value": 4.5
                    },
                    {
                        "name": "Tiene capacidad de hacer cambios para mejorar las pensiones",
                        "value": 2.1
                    },
                    {
                        "name": "Tiene capacidad para gestionar los problemas de la inmigración",
                        "value": 0.5
                    },
                    {
                        "name": "Cuidará el medioambiente",
                        "value": 3.1
                    }
                ]
            }
        ]
            
    }
    useEffect(()=>{
        setData(allData)


    },[Data])
    
    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}
 export default PackeBubbleChart;